export default __webpack_public_path__ + "static/1-bf3813f1c57ebc620bdd9c4c6f09a459.jpg";